"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var EFormFields;
(function (EFormFields) {
  EFormFields["FORM_ID"] = "formId";
  EFormFields["REQUEST_TYPE"] = "request_type";
  EFormFields["SURNAME"] = "surname";
  EFormFields["NAME"] = "name";
  EFormFields["MIDDLE_NAME"] = "middle_name";
  EFormFields["FIO"] = "fio";
  EFormFields["BIRTHDATE"] = "birthdate";
  EFormFields["PASSPORT"] = "passport";
  EFormFields["PASSPORT_CODE"] = "passport_code";
  EFormFields["DOC_ISSUED"] = "doc_issued";
  EFormFields["DOC_WHEN_ISSUED"] = "doc_when_issued";
  EFormFields["DEPOSIT_DATE"] = "deposit_date";
  EFormFields["DEPOSIT_AMOUNT"] = "deposit_amount";
  EFormFields["CREDIT_AMOUNT"] = "credit_amount";
  EFormFields["NEED_SUM"] = "need_sum";
  EFormFields["BANK_NAME"] = "BankName";
  EFormFields["BANK_ID"] = "BankId";
  EFormFields["BANK_NAME_CASHBACK"] = "BankNameCashBack";
  EFormFields["HAS_CASHBACK"] = "cashback";
  EFormFields["GUARANTEE_TYPE"] = "guarantee_type";
  EFormFields["INN_CLIENT"] = "employer_inn";
  EFormFields["LOW_INN_CLIENT"] = "low12month";
  EFormFields["BIC_CLIENT"] = "bikClient";
  EFormFields["BIC_BANK"] = "bikBank";
  EFormFields["RS_CLIENT"] = "rsClient";
  EFormFields["PERSONAL_RS_CLIENT"] = "personalRsClient";
  EFormFields["AGREEMENT"] = "agreement";
  EFormFields["CONDITIONS"] = "conditions";
  EFormFields["REGISTRATION_ADDRESS"] = "registration_address";
  EFormFields["REGISTRATION_ADDRESS_WITHOUT_FLAT"] = "registration_address";
  EFormFields["EMAIL"] = "email";
  EFormFields["USER_ID"] = "userId";
  EFormFields["PHONE"] = "phone";
  EFormFields["PRODUCT_NAME"] = "productName";
  EFormFields["REGION"] = "region";
  EFormFields["ADDITIONAL_INFO"] = "additional_info";
  EFormFields["PARENT_ID"] = "parent_id";
  EFormFields["ORGANIZATION_TYPE"] = "organization_type";
  EFormFields["REGION_ID"] = "region_id";
  EFormFields["ORGANIZATION_NAME"] = "organization_name";
  EFormFields["PRODUCT_TYPE"] = "ProductType";
  EFormFields["PRODUCT_ID"] = "product_id";
  EFormFields["TERM"] = "term";
  EFormFields["PROPERTY_COST"] = "propertyCost";
  EFormFields["PURPOSE_CODE"] = "purpose_code";
  EFormFields["DOWN_PAYMENT"] = "downPayment";
  EFormFields["VITRINA_ONLINE"] = "vitrina_online";
  EFormFields["PARTNER_ID"] = "partnerId";
  EFormFields["MORTGAGE_SELECTION"] = "mortgage_selection";
  EFormFields["REGISTRATION_ASSISTANCE"] = "registration_assistance";
  EFormFields["BANK_APPROVAL"] = "bank_approval";
  EFormFields["SPECIALIST_CONSULTATION"] = "specialist_consultation";
  EFormFields["LANDING"] = "landing";
  EFormFields["COMMENT"] = "comment";
})(EFormFields || (EFormFields = {}));
var _default = EFormFields;
exports.default = _default;